export function InvoiceActivityCtrl ($scope, workshopAPI, activity) {
  $scope.activity = activity[0];
}